import React from 'react';
import { useAppSelector } from 'app/store/store.hooks';
import { IUserModel } from 'entities/User/User.models';

export interface IWithAuthUserProps {
  authUser: IUserModel | null;
}

// Injects the current authUser into class components, which can't call hooks directly.
export function withAuthUser<P extends IWithAuthUserProps>(
  Component: React.ComponentType<P>
): React.FC<Omit<P, keyof IWithAuthUserProps>> {
  return (props) => {
    const authUser = useAppSelector((state) => state.auth.authUser);

    return <Component {...(props as P)} authUser={authUser} />;
  };
}
